import mutations from './firearmPermit.mutations'
import actions from './firearmPermit.actions'
import getters from './firearmPermit.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
